module.exports = __webpack_public_path__ + "assets/img/23.94286d2c.png";